export default "__VITE_ASSET__CEId4d3g__"